import * as React from 'react';

import {CrossBrowserHiddenFormSubmit} from 'shells/form/cross-browser-hidden-form-submit';
import {Label} from 'shells/form/label';

import type {
    MailChimpListBasic as MailChimpListBasicFragment,
    GetClosedLeadEmailAutomation as GetClosedLeadEmailAutomationQuery,
} from 'nutshell-graphql-types';

import {GraphQLSelectMailChimp} from '../../core/select/graphql-select-mailchimp';
import {SalesAutomationSidebarFormWrapper} from '../../core/sidebar/sales-automation-sidebar-form-wrapper';

import styles from './sales-process-form.module.css';

type Props = {
    isFetchingLatestVersion: boolean;
    formSubmitBtnRef: (arg1?: HTMLInputElement | null | undefined) => any;
    subscription: GetClosedLeadEmailAutomationQuery['closedLeadEmailAutomation'] | null | undefined;
    onSave: (listId: string) => any;
    onDelete: (id: string) => Promise<any>;
};

type State = {
    selectedListId: string | null | undefined;
};

export class ClosedLeadMailChimpSubscriptionForm extends React.PureComponent<Props, State> {
    // @ts-expect-error
    mailchimpListSelectFieldRef: HTMLInputElement;

    constructor(props: Props) {
        super(props);

        const {subscription} = props;

        this.state = {
            selectedListId:
                subscription && subscription.emailList ? subscription.emailList.id : null,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        const {subscription} = nextProps;

        if (subscription && !this.props.subscription) {
            this.setState({
                selectedListId: subscription.emailList ? subscription.emailList.id : null,
            });
        }
    }

    render() {
        return (
            <SalesAutomationSidebarFormWrapper
                id={this.props.subscription ? this.props.subscription.id : null}
                isFetchingLatestVersion={this.props.isFetchingLatestVersion}
                onDelete={{
                    deleteText: 'Remove subscription',
                    deleteConfirmationTitle: 'Are you sure you want to remove this subscription?',
                    onDeleteConfirm: this.handleDeleteConfirm,
                }}
                onSaveForm={this.handleSaveForm}
            >
                <h3 className={styles.subheader}>
                    When a lead reaches this outcome, add the lead to a MailChimp list to enter your
                    set of campaigns.
                </h3>
                <div style={{width: 250}} className={styles['form-input']}>
                    <Label htmlFor='mailchimpList'>Add to MailChimp list</Label>
                    <GraphQLSelectMailChimp
                        onClearValue={() => this.setState({selectedListId: undefined})}
                        onChange={this.handleAddToListChange}
                        selectedId={this.state.selectedListId}
                    />
                </div>
                <CrossBrowserHiddenFormSubmit inputRef={this.props.formSubmitBtnRef} />
            </SalesAutomationSidebarFormWrapper>
        );
    }

    handleAddToListChange = (list: MailChimpListBasicFragment) => {
        this.setState({selectedListId: list.id});
    };

    handleDeleteConfirm = (id: string) => {
        return this.props.onDelete(id);
    };

    handleSaveForm = () => {
        if (this.state.selectedListId) return this.props.onSave(this.state.selectedListId);
    };
}
